import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import routes from "../../../AppRouter/routes";

import Settings from "./Settings";
import SpecimenDetails from "./SpecimenDetails";
import SuperUserPanel from "./SuperUserPanel";
import ActivityMonitor from "./ActivityMonitor";
import TrapSite from "./TrapSite";
import TrapCollectionMethod from "./TrapCollectionMethod";
import Device from "./Device";
import TabContent from "../../SideBar/TabContent";

const DetailsRouter = () => {
  return (
    <Switch>
      <Route exact path={routes.detailsTab}>
        <TabContent>
          <Redirect to={routes.trapSite} value={routes.trapSite} />
        </TabContent>
      </Route>
      <Route path={routes.trayDetails}>
        <TabContent>
          <SpecimenDetails />
        </TabContent>
      </Route>
      <Route path={routes.trapSite}>
        <TabContent value={routes.trapSite} index={routes.trapSite}>
          <TrapSite />
        </TabContent>
      </Route>
      <Route path={routes.collectionMethods}>
        <TabContent
          value={routes.collectionMethods}
          index={routes.collectionMethods}
        >
          <TrapCollectionMethod />
        </TabContent>
      </Route>
      <Route path={routes.superUserPanel}>
        <TabContent>
          <SuperUserPanel />
        </TabContent>
      </Route>
      <Route path={routes.activity}>
        <TabContent>
          <ActivityMonitor />
        </TabContent>
      </Route>
      <Route path={routes.settings}>
        <TabContent>
          <Settings />
        </TabContent>
      </Route>

      <Route path={routes.toolDetails}>
        <TabContent>
          <Device />
        </TabContent>
      </Route>
    </Switch>
  );
};

export default DetailsRouter;
